/**
 * Created by andrey on 25.09.2025
 */

const CloudStorageProxy = function (cloudStorage) {
    this.cloudStorage = cloudStorage;
};

CloudStorageProxy.prototype.getItem = function (key) {
    return this.cloudStorage.getItem(key);
};

CloudStorageProxy.prototype.getData = function (prefix = "") {
    return this.cloudStorage.getData(prefix);
};

CloudStorageProxy.prototype.setItem = function (key, value) {
    this.cloudStorage.setItem(key, value);
};

CloudStorageProxy.prototype.removeItem = function (key) {
    this.cloudStorage.removeItem(key);
};

CloudStorageProxy.prototype.clearData = function (prefix = "") {
    this.cloudStorage.clearData(prefix);
};